import axios from "./Api";
// import axios from "axios";

export function addJobApplication(data) {
  return axios.post("/job_application", data);
}